import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import {StoreContext} from "../../stores/contexts";

class CheckMe extends Component {
  static contextType = StoreContext;

  render() {
    const idField=this.context.configStore.config.data.id_field;
    return (
      <label onClick={(e)=>{ console.log("checkbox click"); e.stopPropagation(); }}>
        <input type="checkbox" onClick={(e)=>{ e.stopPropagation(); }} onChange={(e)=>{
          if(e.target.checked) {
            this.context.selectStore.select(this.props.row[idField]);
          } else {
            this.context.selectStore.unselect(this.props.row[idField]);
          }
        }} value="1" checked={this.context.selectStore.selected[this.props.row[idField]]?true:false} /><span></span>
      </label>
    )
  }
}

// export default inject("selectStore","configStore")(observer(CheckMe));
export default observer(CheckMe);